import { useMemo } from 'react'
import { useLocation, matchPath } from 'react-router-dom'

import { FeatureFlagsStore, UserStore } from 'stores'
import { PATHNAMES } from 'utils/routes/consts'

const useIsDesktopNotAllowedRoute = () => {
  const isSoaOnDesktopEnabled = FeatureFlagsStore.getFeatureFlag('isSoaOnDesktopEnabled')
  const isZaiChatEnabled = FeatureFlagsStore.getFeatureFlag('isZaiChatEnabled')

  const isViewer = UserStore.getRole === 'viewer'

  const location = useLocation()

  const isNotAllowedRoute = useMemo(() => {
    const isBrandCategoryPage = matchPath(location?.pathname, {
      path: PATHNAMES.OUTDATED_WORKSPACE_CATEGORY,
      exact: true,
    })
    const isBrandRankingPage = matchPath(location?.pathname, {
      path: PATHNAMES.OUTDATED_WORKSPACE_CATEGORY_RANKING,
      exact: true,
    })
    const isZaiChatPage = matchPath(location?.pathname, { path: PATHNAMES.WORKSPACE_ZAI, exact: true })
    const shouldDisableZaiChatPage = isZaiChatPage && ((isZaiChatEnabled && isViewer) || !isZaiChatEnabled)

    const shouldDisableBrandCategoryPage = !isSoaOnDesktopEnabled && isBrandCategoryPage
    const shouldDisableBrandRankingPage = isBrandRankingPage

    const notAllowedRoutes = [shouldDisableBrandCategoryPage, shouldDisableBrandRankingPage, shouldDisableZaiChatPage]

    return notAllowedRoutes.some(Boolean)
  }, [isSoaOnDesktopEnabled, isZaiChatEnabled, isViewer, location?.pathname])

  return isNotAllowedRoute
}

export default useIsDesktopNotAllowedRoute
